import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "剧情", to: "/category/drama" },
  { label: "角色", to: "/category/characters" },
  { label: "资讯", to: "/category/news" },
  { label: "关于", to: "/about" },
];

export default function SiteNavbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    [
      "relative px-3 py-2 text-sm transition-colors duration-200 whitespace-nowrap",
      isActive
        ? "text-primary-700 font-medium"
        : "text-foreground-600 hover:text-primary-700",
    ].join(" ");

  return (
    <header
      className={[
        "sticky top-0 z-50 w-full transition-all duration-300",
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-300/70"
          : "bg-background-50 border-b border-transparent",
      ].join(" ")}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 group shrink-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-700 text-background-50 font-heading text-lg leading-none">
              妻
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-base md:text-lg font-semibold tracking-wide text-foreground-950">
                我妻子的一切
              </span>
              <span className="mt-0.5 text-[10px] tracking-[0.25em] text-accent-600 uppercase">
                Drama Archive
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-1.5">
            <Link
              to="/search"
              aria-label="搜索"
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-600 transition-colors hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
            >
              <i className="ri-search-line text-lg" />
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((value) => !value)}
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-primary-50 md:hidden cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-300/70 bg-background-50 animate-fade-in">
          <nav className="flex flex-col px-4 py-2">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  [
                    "flex items-center justify-between rounded-md px-3 py-3 text-sm border-b border-background-200/70 last:border-0",
                    isActive ? "text-primary-700 font-medium" : "text-foreground-700",
                  ].join(" ")
                }
              >
                <span>{item.label}</span>
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </NavLink>
            ))}
            <Link
              to="/search"
              className="mt-2 mb-3 flex items-center justify-center gap-2 rounded-md bg-primary-700 px-3 py-3 text-sm text-background-50"
            >
              <i className="ri-search-line" />
              搜索剧集内容
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}